<script>
    import Icon from '../icons/Icon.svelte';

    export let acceptDelivery = true;
    export let acceptPickup = true;
    export let acceptDineIn = true;
    export let minOrderValue = 0.00;
    export let defaultDeliveryFee = 7.00;
    export let estimatedMinutes = 45;
    export let autoAcceptOrders = false;
    export let allowHalfBroto = false;
    export let isPaused = false;
    export let pauseUntil = null;
    export let pauseReason = '';
    export let deliveryFeesList = [];
    export let isLoadingFees = false;
    export let onOpenFeeModal = () => {};
    export let onDeleteFee = () => {};
    export let onTogglePause = () => {};
</script>

<div class="tab-pane">
    <!-- 1. Modalidades de Venda (Canais) -->
    <section class="settings-card">
        <div class="card-header">
            <div class="card-title-group">
                <Icon name="shopping-bag" size={18} />
                <h4>Modalidades & Canais de Atendimento</h4>
            </div>
            <span class="card-subtitle">Ative ou pause os tipos de pedidos que sua operação aceita no momento.</span>
        </div>

        <div class="channels-grid">
            <!-- Delivery -->
            <label class="channel-card {acceptDelivery ? 'active' : ''}">
                <div class="channel-icon-box">
                    <Icon name="motorcycle" size={22} />
                </div>
                <div class="channel-content">
                    <span class="channel-title">Entrega (Delivery)</span>
                    <span class="channel-desc">Permite despacho via motoboys para os endereços dos clientes.</span>
                </div>
                <input type="checkbox" bind:checked={acceptDelivery} class="toggle-checkbox" />
            </label>

            <!-- Retirada -->
            <label class="channel-card {acceptPickup ? 'active' : ''}">
                <div class="channel-icon-box">
                    <Icon name="package" size={22} />
                </div>
                <div class="channel-content">
                    <span class="channel-title">Retirada no Balcão</span>
                    <span class="channel-desc">Cliente busca o pedido pronto diretamente no estabelecimento.</span>
                </div>
                <input type="checkbox" bind:checked={acceptPickup} class="toggle-checkbox" />
            </label>

            <!-- Salão / Mesas -->
            <label class="channel-card {acceptDineIn ? 'active' : ''}">
                <div class="channel-icon-box">
                    <Icon name="table" size={22} />
                </div>
                <div class="channel-content">
                    <span class="channel-title">Consumo no Salão (Mesas)</span>
                    <span class="channel-desc">Habilita comandas e pedidos presenciais para garçons e salão.</span>
                </div>
                <input type="checkbox" bind:checked={acceptDineIn} class="toggle-checkbox" />
            </label>
        </div>
    </section>

    <!-- Pausa Operacional de Emergência (Cozinha Lotada / Contingência) -->
    <section class="settings-card pause-card {isPaused ? 'paused-active' : ''}">
        <div class="pause-header">
            <div class="pause-info">
                <div class="pause-badge-row">
                    <span class="pause-badge {isPaused ? 'is-paused' : 'is-online'}">
                        <span class="pulse-dot"></span>
                        {isPaused ? 'LOJA PAUSADA TEMPORARIAMENTE' : 'LOJA ONLINE & RECEBENDO PEDIDOS'}
                    </span>
                    {#if isPaused && pauseUntil}
                        <span class="pause-until-pill">
                            <Icon name="clock" size={13} />
                            Até {new Date(pauseUntil).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                        </span>
                    {/if}
                </div>
                <h4 class="pause-title">Pausa de Contingência (Cozinha Lotada / Chuva)</h4>
                <p class="pause-desc">
                    {#if isPaused}
                        Os clientes que acessarem o cardápio verão um aviso de pausa temporária. Nenhum novo pedido online entrará até o encerramento da pausa.
                        {#if pauseReason}<br /><strong class="reason-text">Motivo: {pauseReason}</strong>{/if}
                    {:else}
                        Precisa de um respiro na cozinha? Pause temporariamente o recebimento de novos pedidos pelo cardápio digital sem alterar seus horários oficiais.
                    {/if}
                </p>
            </div>
            <div class="pause-actions">
                {#if isPaused}
                    <button
                        type="button"
                        class="btn-resume-store"
                        on:click={() => onTogglePause(false)}
                    >
                        <Icon name="play" size={15} />
                        <span>Despausar Loja Agora</span>
                    </button>
                {:else}
                    <div class="pause-options">
                        <button
                            type="button"
                            class="btn-pause-quick"
                            on:click={() => onTogglePause(true, 30, 'Cozinha com alta demanda de pedidos')}
                        >
                            <Icon name="pause" size={13} />
                            <span>Pausar 30 min</span>
                        </button>
                        <button
                            type="button"
                            class="btn-pause-quick"
                            on:click={() => onTogglePause(true, 60, 'Cozinha em capacidade máxima')}
                        >
                            <Icon name="pause" size={13} />
                            <span>Pausar 1 hora</span>
                        </button>
                    </div>
                {/if}
            </div>
        </div>
    </section>

    <!-- 2. Parâmetros Operacionais de Pedido -->
    <section class="settings-card">
        <div class="card-header">
            <div class="card-title-group">
                <Icon name="clock" size={18} />
                <h4>Parâmetros de Produção & Entrega</h4>
            </div>
            <span class="card-subtitle">Defina valores de referência para o cálculo do cardápio e checkout.</span>
        </div>

        <div class="form-grid">
            <div class="form-group">
                <label for="default-fee">Taxa Padrão de Entrega (R$)</label>
                <div class="input-prefix-box">
                    <span class="prefix">R$</span>
                    <input
                        id="default-fee"
                        type="number"
                        step="0.50"
                        min="0"
                        bind:value={defaultDeliveryFee}
                        placeholder="7.00"
                        class="form-input with-prefix"
                    />
                </div>
            </div>

            <div class="form-group">
                <label for="min-order">Valor Mínimo do Pedido (R$)</label>
                <div class="input-prefix-box">
                    <span class="prefix">R$</span>
                    <input
                        id="min-order"
                        type="number"
                        step="1.00"
                        min="0"
                        bind:value={minOrderValue}
                        placeholder="0.00"
                        class="form-input with-prefix"
                    />
                </div>
            </div>

            <div class="form-group">
                <label for="estimated-mins">Tempo Médio Estimado (Minutos)</label>
                <input
                    id="estimated-mins"
                    type="number"
                    step="5"
                    min="10"
                    bind:value={estimatedMinutes}
                    placeholder="45"
                    class="form-input"
                />
            </div>
        </div>

        <div class="toggle-row">
            <label class="switch-control">
                <input type="checkbox" bind:checked={autoAcceptOrders} />
                <span class="switch-label">
                    <strong>Aceite Automático de Novos Pedidos</strong>
                    <small>Se ativado, pedidos online no WhatsApp e Cardápio entram automaticamente em "Preparando" sem aguardar clique de confirmação.</small>
                </span>
            </label>
        </div>
    </section>


    <!-- 3. Regras de Cardápio & Pizzaria (Fracionamento de Sabores) -->
    <section class="settings-card">
        <div class="card-header">
            <div class="card-title-group">
                <Icon name="pizza" size={18} />
                <h4>Regras de Cardápio & Fracionamento de Pizzas</h4>
            </div>
            <span class="card-subtitle">Personalize a divisão de sabores para produtos fracionados (meio a meio).</span>
        </div>

        <div class="pizza-rules-container">
            <label class="pizza-rule-card {allowHalfBroto ? 'active' : ''}">
                <div class="pizza-rule-icon-box">
                    <Icon name="pizza" size={24} />
                </div>
                <div class="pizza-rule-content">
                    <div class="rule-badge-row">
                        <span class="rule-tag">PIZZA BROTO (4 FATIAS)</span>
                        {#if allowHalfBroto}
                            <span class="rule-status active">2 Sabores Liberado (Meio a Meio)</span>
                        {:else}
                            <span class="rule-status standard">1 Sabor Apenas (Padrão)</span>
                        {/if}
                    </div>
                    <span class="pizza-rule-title">Permitir 2 Sabores (Meio a Meio) na Pizza Broto</span>
                    <span class="pizza-rule-desc">
                        Quando ativado, os clientes no <strong>Cardápio Digital</strong> e atendentes no <strong>Painel de Mesas / PDV</strong> poderão selecionar até <strong>2 sabores</strong> para pizzas do tamanho Broto / Pequena (4 fatias). Se desativado, o sistema bloqueia em 1 sabor único.
                    </span>
                </div>
                <input type="checkbox" bind:checked={allowHalfBroto} class="toggle-checkbox" />
            </label>
        </div>
    </section>

    <!-- 4. Tabela de Bairros & Taxas de Entrega Específicas -->
    <section class="settings-card">
        <div class="card-header fee-header">
            <div>
                <div class="card-title-group">
                    <Icon name="map-pin" size={18} />
                    <h4>Bairros & Taxas Diferenciadas</h4>
                </div>
                <span class="card-subtitle">Cadastre taxas específicas para bairros mais distantes ou tempos de entrega maiores.</span>
            </div>
            <button type="button" class="btn-add-fee" on:click={() => onOpenFeeModal(null)}>
                <Icon name="plus" size={14} />
                <span>+ Adicionar Bairro</span>
            </button>
        </div>

        {#if isLoadingFees}
            <div class="loading-fees">
                <Icon name="refresh" size={16} />
                <span>Carregando bairros atendidos...</span>
            </div>
        {:else if deliveryFeesList.length === 0}
            <div class="empty-fees-box">
                <Icon name="motorcycle" size={28} />
                <p>Nenhum bairro com taxa diferenciada cadastrado. Todos os pedidos usarão a taxa padrão de <strong>R$ {parseFloat(defaultDeliveryFee || 0).toFixed(2)}</strong>.</p>
            </div>
        {:else}
            <div class="fees-table-wrapper">
                <table class="fees-table">
                    <thead>
                        <tr>
                            <th>Bairro / Região</th>
                            <th>Taxa de Entrega</th>
                            <th>Tempo Estimado</th>
                            <th class="text-right">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each deliveryFeesList as fee}
                            <tr>
                                <td class="font-bold">{fee.neighborhood}</td>
                                <td class="fee-badge">R$ {parseFloat(fee.fee || 0).toFixed(2)}</td>
                                <td class="time-text">{fee.estimated_minutes || estimatedMinutes} min</td>
                                <td class="text-right">
                                    <div class="actions-inline">
                                        <button
                                            type="button"
                                            class="btn-row-edit"
                                            title="Editar"
                                            on:click={() => onOpenFeeModal(fee)}
                                        >
                                            <Icon name="edit" size={13} />
                                        </button>
                                        <button
                                            type="button"
                                            class="btn-row-del"
                                            title="Excluir"
                                            on:click={() => onDeleteFee(fee)}
                                        >
                                            <Icon name="trash" size={13} />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        {/if}
    </section>
</div>

<style>
    .tab-pane {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .settings-card {
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 12px;
        padding: 22px 24px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
    }

    .card-header {
        margin-bottom: 16px;
    }

    .fee-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        flex-wrap: wrap;
    }

    .card-title-group {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #0F172A;
    }

    .card-title-group h4 {
        font-size: 15px;
        font-weight: 700;
        color: #0F172A;
        margin: 0;
    }

    .card-subtitle {
        font-size: 12.5px;
        color: #64748B;
        display: block;
        margin-top: 3px;
    }

    .channels-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
        gap: 14px;
    }

    .channel-card {
        display: flex;
        align-items: center;
        gap: 14px;
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        border-radius: 10px;
        padding: 14px 16px;
        cursor: pointer;
        transition: all 0.15s ease;
    }

    .channel-card:hover {
        border-color: #94A3B8;
        background: #F8FAFC;
    }

    .channel-card.active {
        border-color: #FF6A00;
        background: rgba(255, 106, 0, 0.04);
        box-shadow: 0 1px 4px rgba(255, 106, 0, 0.15);
    }

    .channel-icon-box {
        width: 40px;
        height: 40px;
        border-radius: 8px;
        background: #F1F5F9;
        border: 1px solid #E2E8F0;
        color: #475569;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        transition: all 0.15s ease;
    }

    .channel-card.active .channel-icon-box {
        background: #FF6A00;
        color: #FFFFFF;
        border-color: #EA580C;
    }

    .channel-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    .channel-title {
        font-size: 13.5px;
        font-weight: 700;
        color: #0F172A;
    }

    .channel-desc {
        font-size: 11.5px;
        color: #64748B;
        line-height: 1.35;
    }

    .toggle-checkbox {
        width: 18px;
        height: 18px;
        accent-color: #FF6A00;
        cursor: pointer;
    }

    /* Pausa de Emergência */
    .pause-card {
        border: 1px solid #E2E8F0;
        border-left: 4px solid #3B82F6;
        background: #F8FAFC;
        border-radius: 12px;
        padding: 18px 22px;
        transition: all 0.2s ease;
    }

    .pause-card.paused-active {
        border-left-color: #D97706;
        background: #FFFBEB;
        border-color: #FDE68A;
    }

    .pause-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 20px;
        flex-wrap: wrap;
    }

    .pause-info {
        flex: 1;
        min-width: 260px;
    }

    .pause-badge-row {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 6px;
    }

    .pause-badge {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        padding: 3px 10px;
        border-radius: 999px;
    }

    .pause-badge.is-online {
        background: #DCFCE7;
        color: #15803D;
        border: 1px solid #BBF7D0;
    }

    .pause-badge.is-paused {
        background: #FEF3C7;
        color: #B45309;
        border: 1px solid #FDE68A;
    }

    .pulse-dot {
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: currentColor;
    }

    .pause-until-pill {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        font-size: 12px;
        color: #475569;
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        padding: 2px 8px;
        border-radius: 6px;
    }

    .pause-title {
        font-size: 15px;
        font-weight: 700;
        color: #0F172A;
        margin: 0 0 3px 0;
    }

    .pause-desc {
        font-size: 12.5px;
        color: #64748B;
        margin: 0;
        line-height: 1.4;
    }

    .reason-text {
        color: #B45309;
    }

    .pause-actions {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .pause-options {
        display: flex;
        gap: 8px;
    }

    .btn-pause-quick {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        color: #334155;
        font-size: 12px;
        font-weight: 600;
        padding: 8px 12px;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.15s ease;
    }

    .btn-pause-quick:hover {
        background: #FFFBEB;
        border-color: #D97706;
        color: #B45309;
    }

    .btn-resume-store {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: #16A34A;
        color: #FFFFFF;
        font-size: 13px;
        font-weight: 700;
        border: none;
        padding: 9px 18px;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.15s ease;
        box-shadow: 0 2px 6px rgba(22, 163, 74, 0.3);
    }

    .btn-resume-store:hover {
        background: #15803D;
        transform: translateY(-1px);
    }

    .form-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
        gap: 16px;
        margin-bottom: 16px;
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .form-group label {
        font-size: 12.5px;
        font-weight: 600;
        color: #334155;
    }

    .form-input {
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        border-radius: 8px;
        padding: 9px 12px;
        color: #0F172A;
        font-size: 13px;
        outline: none;
        transition: border-color 0.15s ease, box-shadow 0.15s ease;
    }

    .form-input:focus {
        border-color: #FF6A00;
        box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.15);
    }

    .input-prefix-box {
        position: relative;
        display: flex;
        align-items: center;
    }

    .prefix {
        position: absolute;
        left: 12px;
        font-size: 13px;
        color: #64748B;
        font-weight: 600;
        pointer-events: none;
    }

    .form-input.with-prefix {
        padding-left: 36px;
        width: 100%;
    }

    .toggle-row {
        border-top: 1px solid #E2E8F0;
        padding-top: 14px;
    }

    .switch-control {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        cursor: pointer;
    }

    .switch-control input {
        margin-top: 3px;
        accent-color: #FF6A00;
        width: 16px;
        height: 16px;
    }

    .switch-label strong {
        font-size: 13px;
        color: #0F172A;
        display: block;
    }

    .switch-label small {
        font-size: 12px;
        color: #64748B;
        line-height: 1.4;
    }

    .btn-add-fee {
        background: #FF6A00;
        color: #FFFFFF;
        border: 1px solid #EA580C;
        padding: 8px 14px;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 700;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        transition: all 0.15s ease;
        box-shadow: 0 1px 3px rgba(255, 106, 0, 0.2);
    }

    .btn-add-fee:hover {
        background: #EA580C;
        transform: translateY(-1px);
    }

    .empty-fees-box {
        text-align: center;
        padding: 36px 20px;
        color: #64748B;
        background: #F8FAFC;
        border: 1px dashed #CBD5E1;
        border-radius: 8px;
    }

    .empty-fees-box p {
        font-size: 13px;
        margin: 8px 0 0 0;
    }

    .loading-fees {
        display: flex;
        align-items: center;
        gap: 10px;
        color: #64748B;
        padding: 20px;
        font-size: 13px;
    }

    .fees-table-wrapper {
        overflow-x: auto;
        border: 1px solid #E2E8F0;
        border-radius: 8px;
    }

    .fees-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 13px;
        text-align: left;
    }

    .fees-table th {
        padding: 10px 14px;
        background: #F8FAFC;
        border-bottom: 1px solid #E2E8F0;
        color: #475569;
        font-weight: 700;
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.05em;
    }

    .fees-table td {
        padding: 12px 14px;
        border-bottom: 1px solid #F1F5F9;
        color: #0F172A;
    }

    .font-bold {
        font-weight: 700;
        color: #0F172A;
    }

    .fee-badge {
        font-weight: 700;
        color: #16A34A;
    }

    .time-text {
        color: #64748B;
    }

    .text-right {
        text-align: right;
    }

    .actions-inline {
        display: inline-flex;
        align-items: center;
        gap: 6px;
    }

    .btn-row-edit, .btn-row-del {
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        color: #475569;
        padding: 5px 8px;
        border-radius: 5px;
        cursor: pointer;
        transition: all 0.15s ease;
    }

    .btn-row-edit:hover {
        background: #EFF6FF;
        border-color: #93C5FD;
        color: #2563EB;
    }

    .btn-row-del:hover {
        background: #FEF2F2;
        border-color: #FCA5A5;
        color: #DC2626;
    }

    /* Regras de Pizzaria & Fracionamento */
    .pizza-rules-container {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .pizza-rule-card {
        display: flex;
        align-items: flex-start;
        gap: 16px;
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        border-radius: 10px;
        padding: 16px 18px;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .pizza-rule-card:hover {
        border-color: #94A3B8;
        background: #F8FAFC;
    }

    .pizza-rule-card.active {
        border-color: #FF6A00;
        background: rgba(255, 106, 0, 0.03);
        box-shadow: 0 1px 4px rgba(255, 106, 0, 0.12);
    }

    .pizza-rule-icon-box {
        width: 44px;
        height: 44px;
        border-radius: 10px;
        background: #F1F5F9;
        border: 1px solid #E2E8F0;
        color: #475569;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        transition: all 0.2s ease;
    }

    .pizza-rule-card.active .pizza-rule-icon-box {
        background: #FF6A00;
        color: #FFFFFF;
        border-color: #EA580C;
    }

    .pizza-rule-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .rule-badge-row {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
        margin-bottom: 2px;
    }

    .rule-tag {
        font-size: 10.5px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        padding: 2px 7px;
        border-radius: 4px;
        background: #F1F5F9;
        color: #475569;
        border: 1px solid #E2E8F0;
    }

    .rule-status {
        font-size: 11px;
        font-weight: 600;
        padding: 2px 8px;
        border-radius: 999px;
    }

    .rule-status.active {
        background: #DCFCE7;
        color: #15803D;
        border: 1px solid #BBF7D0;
    }

    .rule-status.standard {
        background: #F1F5F9;
        color: #64748B;
        border: 1px solid #E2E8F0;
    }

    .pizza-rule-title {
        font-size: 14px;
        font-weight: 700;
        color: #0F172A;
    }

    .pizza-rule-desc {
        font-size: 12.5px;
        color: #64748B;
        line-height: 1.45;
    }

    .pizza-rule-desc strong {
        color: #334155;
    }

</style>
